import ClientService from '../../../services/client-service';
import getAccountListData from '../../../graphql/query/get-account-list-data.graphql';
import saveAccountListDataMutation from '../../../graphql/mutation/save-account-list-data.graphql';
import deleteAccountMutation from '../../../graphql/mutation/delete-account.graphql';
import sendAccountNotificationMutation from '../../../graphql/mutation/send-account-notification.graphql';

export default class SettingsAccountListApi {
  public static getAccountListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getAccountListData, payload);
  }

  public static saveAccountListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveAccountListDataMutation, payload);
  }

  public static deleteAccount(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteAccountMutation, payload);
  }

  public static sendAccountNotification(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(sendAccountNotificationMutation, payload);
  }
}
